export enum FloorFormTabType {
  REMARK = "REMARK",
  ATTACHMENTS = "ATTACHMENTS",
  CLARIFICATION_REQUEST = "CLARIFICATION_REQUEST"
}
